import { API, Environment } from 'sdk'

const environment = (process.env.NODE_ENV === 'production')
  ? Environment.Production
  : Environment.Local;

export default API({ environment });
